import { Injectable } from '@angular/core';
import { CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';
import {SessionService} from './session.service';

@Injectable()
export class NonPermissionGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router, private sessionService: SessionService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
        if (this.authService.isLoggedIn()) {
            let userGroups = this.sessionService.getUserGroups();
            let permissions = this.sessionService.getUserDetails().viewPermissions;
            if (!permissions)
                return true;
            if (userGroups.indexOf('administrator') > -1 || userGroups.indexOf('view-administrator') > -1 || userGroups.indexOf('itpx') > -1)
                return true;
            if (url.includes('supplier-management') && !permissions['vmsEnabled']) {
                this.router.navigate(['/unauthorized']);
            }
            if (url.includes('classes') && !permissions['classes']) {
                this.router.navigate(['/unauthorized']);
            }
            if (url.includes('solar') && !permissions['voucherManagement']) {
                this.router.navigate(['/unauthorized']);
            }
            if (url.includes('contracts') && !permissions['contracts']) {
                this.router.navigate(['/unauthorized']);
            }
            if (url.includes('order-management') && !permissions['ordersAndInvoices']) {
                this.router.navigate(['/unauthorized']);
            }
            return true
        }

        // Store the attempted URL for redirecting
        // this.authService.redirectUrl = url;

        // Navigate to the login page with extras
        this.router.navigate(['/dashboard']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/non-permission-guard.service.ts